import styled from '@emotion/styled';
import { useEffect, useState } from 'react';

import { round } from '../../lib/math';
import { ToastManager } from '../../ToastManager';

import { useMount } from '../../hooks/useMount';
import { useApi, useSelectedHomeyConnection } from '../../store/SelectedHomeyStore.hooks';

import { su } from '../../theme/functions/su';
import { theme } from '../../theme/theme';

import { Heading4 } from '../../components/common/text/Heading4';

export function Weather() {
  const { api } = useApi();
  const { connectionEpoch } = useSelectedHomeyConnection();
  const [state, setState] = useState('');
  const mount = useMount();

  useEffect(() => {
    if (api == null) {
      return;
    }

    let isActive = true;

    function setter(result) {
      const temperature = round(result.temperature ?? 0, 0);
      const temperatureUnits = result.temperatureUnits ?? '°C';
      const weatherState = result.state ?? '';
      const message = weatherState
        ? `${temperature} ${temperatureUnits} • ${weatherState}`
        : `${temperature} ${temperatureUnits}`;

      if (mount.isMounted) {
        setState(message);
      }
    }

    api.weather.on('weather', setter);
    const leasePromise = api.weather.acquireConnection().catch((error) => {
      ToastManager.handleError(error);
      return null;
    });

    async function fetchWeather() {
      const lease = await leasePromise;

      if (lease == null || isActive === false) {
        return;
      }

      try {
        const result = await api.weather.getWeather();

        if (isActive === true) {
          setter(result);
        }
      } catch (error) {}
    }

    fetchWeather().catch(ToastManager.handleError);

    return function () {
      isActive = false;
      api.weather.off('weather', setter);
      leasePromise
        .then(async (lease) => {
          await lease?.release();
        })
        .catch(ToastManager.handleError);
    };
  }, [api, mount, connectionEpoch]);

  return (
    <sc.Weather lineHeight="24px" color={theme.color.text_light}>
      {state}
    </sc.Weather>
  );
}

const sc = {};

sc.Weather = styled(Heading4)`
  margin-top: ${su(1)};
  min-height: 24px;
`;
